/**
 * Simple function to convert flat data with parentId to nested tree structure
 * @param {Array} flatData - Array of items with id, name, type, and parentId
 * @returns {Array} - Nested tree structure with children
 */
function buildTree(flatData) {
  const keyOf = (id) =>
    id == null || id === "" ? null : String(id).trim().toLowerCase();
  const itemMap = {};

  flatData.forEach((item) => {
    itemMap[keyOf(item.id)] = {
      ...item,
      name: item.type === "placeholder" ? item.name : (item.name?.toLowerCase?.() || item.name),
      children: [],
    };
  });

  const tree = [];
  const orphans = [];

  flatData.forEach((item) => {
    const node = itemMap[keyOf(item.id)];
    if (!item.parentId) {
      tree.push(node);
    } else if (itemMap[keyOf(item.parentId)]) {
      itemMap[keyOf(item.parentId)].children.push(node);
    } else {
      orphans.push(node);
    }
  });

  /* Orphans: attach linked files to folder fallback rather than hide or root them. */
  orphans.forEach((node) => {
    const parentKey = keyOf(node.parentId);
    const fallbackKey = keyOf(node.folderFallbackId);
    if (node.type === "file" && parentKey?.startsWith("ph-")) {
      if (itemMap[parentKey]) {
        itemMap[parentKey].children.push(node);
        return;
      }
      const phFromDoc = keyOf(
        node.studyPlaceholderId
          ? `ph-${node.studyPlaceholderId}`
          : null,
      );
      if (phFromDoc && itemMap[phFromDoc]) {
        itemMap[phFromDoc].children.push(node);
        return;
      }
      if (fallbackKey && itemMap[fallbackKey]) {
        itemMap[fallbackKey].children.push(node);
        return;
      }
    }
    tree.push(node);
  });

  // Remove empty children arrays
  const clean = (items) => {
    items.forEach((item) => {
      if (item.children?.length === 0) delete item.children;
      else if (item.children) clean(item.children);
    });
  };
  clean(tree);

  return tree;
}

// ✅ Standard React/ESM export (only this is needed)
export default buildTree;
